import { Lock, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { MODULES_META } from '../../constants/modules-meta';
import { ROUTES } from '../../constants/routes';

interface UpgradePromptProps {
  moduleId: string;
  open: boolean;
  onClose: () => void;
}

export default function UpgradePrompt({ moduleId, open, onClose }: UpgradePromptProps) {
  const navigate = useNavigate();
  const meta = MODULES_META[moduleId];

  if (!meta) return null;

  const handleGoToSubscription = () => {
    onClose();
    navigate(`${ROUTES.UPGRADE}?module=${moduleId}`);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100">
              <Lock className="h-5 w-5 text-amber-600" />
            </div>
            <DialogTitle className="text-lg">{meta.name}</DialogTitle>
          </div>
        </DialogHeader>

        <p className="text-sm text-gray-500 mb-4">{meta.description}</p>

        <ul className="space-y-2 mb-6">
          {meta.features.map((feature) => (
            <li key={feature} className="flex items-center gap-2 text-sm text-gray-700">
              <CheckCircle2 className="h-4 w-4 text-green-500 shrink-0" />
              {feature}
            </li>
          ))}
        </ul>

        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={onClose}>
            Cancel
          </Button>
          <Button
            className="flex-1 bg-primary text-white hover:bg-primary-dark"
            onClick={handleGoToSubscription}
          >
            Go to Subscription
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
